import React, { useState } from 'react';
import { Form, Select, Drawer, Typography, Input, Button, List } from 'antd';
import { formatDistanceToNow } from 'date-fns';
const { Text } = Typography;

const PromotionMetrices = ({ data, value, onChange, readiness, onReadinessChange, isReady, isReadyChange }) => {

  const [drawerVisible, setDrawerVisible] = useState(false);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const onCloseDrawer = () => {
    setDrawerVisible(false);
  };



  return (
    <div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} >
        <h2>Promotion</h2>
        <Text italic>
          (Note : Editable for Talent Review Calibration)
        </Text>
      </div>
      <div style={{ display: 'flex', alignContent: 'center', gap: '20px' }}>
        <Form.Item label="Ready For Promotion" style={{ fontWeight: 'bold' }} name="readyforpromotion" rules={[{ required: true, message: 'Please select Label 2' }]}>
          <Select value={isReady} onChange={isReadyChange} style={{ width: '150px', fontSize: '10px' }} placeholder="Select an option" >
            <Select.Option value="4"  >Strong Yes</Select.Option>
            <Select.Option value="3" >Yes</Select.Option>
            <Select.Option value="2" >No</Select.Option>
            <Select.Option value="1" >Strong No</Select.Option>
          </Select>
          <Text style={{ fontSize: 12 }}></Text>
        </Form.Item>

        <Form.Item label="Readiness" style={{ fontWeight: 'bold' }} name="promotionreadiness" rules={[{ required: true, message: 'Please select Label 2' }]}>
          <Select value={readiness} onChange={onReadinessChange} style={{ width: '150px', fontSize: '10px' }} placeholder="Select an option" >
            <Select.Option value="5" title="Immediate time-frame for move,  Employee ready to take on new responsibility in next 0-6 months.">0-6 months</Select.Option>
            <Select.Option value="4" title="Intermediate time-frame for move over next 7-18 months,  assuming progress in current role.">6-18 months</Select.Option>
            <Select.Option value="3" title="Long-term time frame for move.  May be ready in next 18-36 months. ">18-36 months</Select.Option>
            <Select.Option value="2" title="Focus on growing in current role">36+ months</Select.Option>
            <Select.Option value="1" title="Immediate management attention required ">Action Required</Select.Option>
          </Select>
          <Text style={{ fontSize: 12 }}></Text>
        </Form.Item>
        <div style={{ display: 'flex', alignContent: 'center', gap: '5px' }}>
          <Form.Item label="Comments" style={{ fontWeight: 'bold' }} rules={[{ required: true, message: 'Please select ' }]}>

            <Input.TextArea style={{ width: 500 }} autoSize={{ minRows: 4, maxRows: 4 }} placeholder="Enter your comment here" value={value} onChange={onChange} />
          </Form.Item>
          <Button type='primary' onClick={showDrawer}>View Comments</Button>
        </div>

      </div>




      <Drawer
        title="Overall Comments"
        placement="right"
        width={500}
        closable={false}
        onClose={onCloseDrawer}
        visible={drawerVisible}
      >


        <List>
          <List.Item>
            <Text style={{ padding: '5px', borderRadius: '8px', fontSize: '16px', backgroundColor: '#F9E79F' }}>{data.managerNameForComment}</Text>
          </List.Item>
          <List.Item>
            <div>
              <Text style={{ fontSize: '15px', fontWeight: 'bold' }}>Functional Competencies - Comments</Text>
              <br />

              <br />
              <Text style={{ fontSize: '15px' }}>{data.funcCompComment}</Text>
            </div>
          </List.Item>
          <List.Item>
            <div>
              <Text style={{ fontSize: '15px', fontWeight: 'bold' }}>Core Competencies - Comments</Text>
              <br />
              <br />
              <Text style={{ fontSize: '15px' }}>{data.coreCompComment}</Text>
            </div>
          </List.Item>
          <List.Item>
            <div>
              <Text style={{ fontSize: '15px', fontWeight: 'bold' }}>Overall - Comments</Text>
              <br />
              <br />
              <Text style={{ fontSize: '15px' }}>{data.overallComment}</Text>
            </div>
          </List.Item>
          <List.Item>
            <div>
              <Text style={{ fontSize: '15px', fontWeight: 'bold' }}>Promotion - Comments</Text>
              <br />
              <br />
              <Text style={{ fontSize: '15px' }}>{data.promotionComment}</Text>
              <br />
            </div>
          </List.Item>
          {data.comments && (
            <List.Item>
              <div>
                <Text style={{ padding: '5px', borderRadius: '8px', fontSize: '16px', backgroundColor: '#F9E79F' }}>{data.managerName}</Text>
                <br />
                <Text type='secondary' style={{ padding: '8px', borderRadius: '8px', fontSize: '13px' }}>{formatDistanceToNow(new Date(data.commentDate), { addSuffix: true })}</Text>
                <br />
                <br />
                <Text style={{ padding: '8px', borderRadius: '8px', fontSize: '15px' }}>{data.comments}</Text>
              </div>
            </List.Item>
          )}
        </List>
      </Drawer>
    </div>

  );
};

export default PromotionMetrices;
